export default function findMessageId(fields) {
	return fields.reduce((accumulator, { type, admin_label, id }) => {
		// eslint-disable-next-line camelcase
		const found = (type === 'textarea') && (admin_label === 'formComment');
		if (found) {
			// eslint-disable-next-line camelcase
			return id;
		}
		return accumulator;
	}, false);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/source-form-locators/findMessageId.js